import request from '@/utils/request'

export function getChangeLog(data) {
    return request({
        url: '/work/room/orderChanges',
        method: 'post',
        data,
    })
}